import { constants, object } from 'common/helpers'


export const initialState = {
  currStep: constants.upgradeSubscriptionFlowSteps.selectPlan,
  currScentIndex: null,
  currMonthIndex: null,
  activeScentIndex: null,
  activeMonthIndex: null,
}

export const update = (state, payload) => (
  object.mergeDeep(state, payload)
)

export const setActiveScentIndex = (state, payload) => (
  { ...state, activeScentIndex: payload }
)

export const setActiveMonthIndex = (state, payload) => (
  { ...state, activeMonthIndex: payload }
)

export const setCurrStep = (state, payload) => (
  { ...state, currStep: payload }
)
